// src/pages/ServicesPage.js

import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';
import '../services/ServicePage.css';

// Import images
import servicesImage from '../../assets/services/services.jpg';
import airportImage from '../../assets/services/airport.jpg';
import parcelImage from '../../assets/services/parcel.jpg';
import schoolImage from '../../assets/services/school.jpg';
import skiImage from '../../assets/services/ski.jpg';
import wheelchairImage from '../../assets/services/wheelchair.jpg';
import medicalImage from '../../assets/services/medical.jpg';
import { FaArrowRight } from 'react-icons/fa';

function ServicesPage() {
  const services = [
    {
      title: 'Courses Scolaires',
      description: 'Transport sécurisé pour les élèves avec chauffeurs expérimentés et véhicules adaptés. Service régulier et ponctuel pour la tranquillité des parents.',
      image: schoolImage,
      path: '/services/courses-scolaires'
    },
    {
      title: 'Navette Aéroport',
      description: 'Transferts vers tous les aéroports de la région avec prise en charge à domicile. Service ponctuel et confortable pour vos voyages.',
      image: airportImage,
      path: '/services/navette-aeroport'
    },
    {
      title: 'Stations de Ski',
      description: 'Transport vers les stations de ski avec équipement adapté pour vos bagages et matériel. Service disponible pour groupes et particuliers.',
      image: skiImage,
      path: '/services/stations-ski'
    },
    {
      title: 'Transport de Colis',
      description: 'Livraison rapide et sécurisée de vos colis dans toute la région. Service professionnel avec suivi en temps réel.',
      image: parcelImage,
      path: '/services/transport-colis'
    },
    {
      title: 'Transport Médical',
      description: 'Transport adapté pour rendez-vous médicaux avec assistance personnalisée. Véhicules équipés et chauffeurs formés.',
      image: medicalImage,
      path: '/services/transport-medical'
    },
    {
      title: 'Mobilité Réduite',
      description: 'Véhicules adaptés et assistance professionnelle pour personnes à mobilité réduite. Service attentionné et personnalisé.',
      image: wheelchairImage,
      path: '/services/mobilite-reduite'
    }
  ];

  return (
    <main className="service-page">
      {/* Hero Section */}
      <section className="service-hero" style={{ backgroundImage: `url(${servicesImage})` }}>
        <div className="service-hero-overlay"></div>
        <div className="service-hero-content">
          <h1>Nos Services</h1>
          <p>Des solutions de transport adaptées à tous vos besoins</p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="service-content">
        <div className="service-container">
          <div className="services-overview-grid">
            {services.map((service, index) => (
              <div className="services-overview-card" key={index}>
                <Link to={service.path}>
                  <div className="services-overview-image-container">
                    <img src={service.image} alt={service.title} />
                  </div>
                  <div className="services-overview-content">
                    <h2>{service.title}</h2>
                    <p>{service.description}</p>
                    <button className="services-overview-button">
                      En savoir plus <FaArrowRight className="arrow-icon" />
                    </button>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}

export default ServicesPage;
